// source: proto/accountpb/owner.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_type_date_pb = require('../../google/type/date_pb.js');
goog.object.extend(proto, google_type_date_pb);
var proto_accountpb_address_pb = require('../../proto/accountpb/address_pb.js');
goog.object.extend(proto, proto_accountpb_address_pb);
var proto_accountpb_contactinfo_pb = require('../../proto/accountpb/contactinfo_pb.js');
goog.object.extend(proto, proto_accountpb_contactinfo_pb);
goog.exportSymbol('proto.accountpb.BatchCreateOwnerRequest', null, global);
goog.exportSymbol('proto.accountpb.BatchCreateOwnerResponse', null, global);
goog.exportSymbol('proto.accountpb.CreateOwnerResponse', null, global);
goog.exportSymbol('proto.accountpb.ListOwnerAutoFillRequest', null, global);
goog.exportSymbol('proto.accountpb.ListOwnerAutoFillResponse', null, global);
goog.exportSymbol('proto.accountpb.Owner', null, global);
goog.exportSymbol('proto.accountpb.OwnerAutoFill', null, global);
goog.exportSymbol('proto.accountpb.UpdateOwnerResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountpb.Owner = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountpb.Owner.repeatedFields_, null);
};
goog.inherits(proto.accountpb.Owner, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountpb.Owner.displayName = 'proto.accountpb.Owner';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountpb.CreateOwnerResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountpb.CreateOwnerResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountpb.CreateOwnerResponse.displayName = 'proto.accountpb.CreateOwnerResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountpb.UpdateOwnerResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountpb.UpdateOwnerResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountpb.UpdateOwnerResponse.displayName = 'proto.accountpb.UpdateOwnerResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountpb.BatchCreateOwnerRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountpb.BatchCreateOwnerRequest.repeatedFields_, null);
};
goog.inherits(proto.accountpb.BatchCreateOwnerRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountpb.BatchCreateOwnerRequest.displayName = 'proto.accountpb.BatchCreateOwnerRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountpb.BatchCreateOwnerResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountpb.BatchCreateOwnerResponse.repeatedFields_, null);
};
goog.inherits(proto.accountpb.BatchCreateOwnerResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountpb.BatchCreateOwnerResponse.displayName = 'proto.accountpb.BatchCreateOwnerResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountpb.OwnerAutoFill = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountpb.OwnerAutoFill, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountpb.OwnerAutoFill.displayName = 'proto.accountpb.OwnerAutoFill';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountpb.ListOwnerAutoFillRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountpb.ListOwnerAutoFillRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountpb.ListOwnerAutoFillRequest.displayName = 'proto.accountpb.ListOwnerAutoFillRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountpb.ListOwnerAutoFillResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountpb.ListOwnerAutoFillResponse.repeatedFields_, null);
};
goog.inherits(proto.accountpb.ListOwnerAutoFillResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountpb.ListOwnerAutoFillResponse.displayName = 'proto.accountpb.ListOwnerAutoFillResponse';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountpb.Owner.repeatedFields_ = [48,49];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountpb.Owner.prototype.toObject = function(opt_includeInstance) {
  return proto.accountpb.Owner.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountpb.Owner} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountpb.Owner.toObject = function(includeInstance, msg) {
  var f, obj = {
    ownerId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    accountId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    ownerType: jspb.Message.getFieldWithDefault(msg, 3, ""),
    firstName: jspb.Message.getFieldWithDefault(msg, 4, ""),
    middleName: jspb.Message.getFieldWithDefault(msg, 5, ""),
    lastName: jspb.Message.getFieldWithDefault(msg, 6, ""),
    status: jspb.Message.getFieldWithDefault(msg, 7, ""),
    createdBy: jspb.Message.getFieldWithDefault(msg, 8, ""),
    dateOfBirth: (f = msg.getDateOfBirth()) && google_type_date_pb.Date.toObject(includeInstance, f),
    country: jspb.Message.getFieldWithDefault(msg, 10, ""),
    employmentStatus: jspb.Message.getFieldWithDefault(msg, 11, ""),
    employmentOccupation: jspb.Message.getFieldWithDefault(msg, 12, ""),
    employmentName: jspb.Message.getFieldWithDefault(msg, 13, ""),
    ownership: jspb.Message.getBooleanFieldWithDefault(msg, 14, false),
    stockOwnership: jspb.Message.getFieldWithDefault(msg, 15, ""),
    brokerMember: jspb.Message.getBooleanFieldWithDefault(msg, 16, false),
    brokerName: jspb.Message.getFieldWithDefault(msg, 17, ""),
    affiliatePerson: jspb.Message.getFieldWithDefault(msg, 18, ""),
    affiliatePersonPosition: jspb.Message.getFieldWithDefault(msg, 19, ""),
    modifiedAt: (f = msg.getModifiedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    modifiedBy: jspb.Message.getFieldWithDefault(msg, 21, ""),
    createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    correspondent: jspb.Message.getFieldWithDefault(msg, 23, ""),
    accountNo: jspb.Message.getFieldWithDefault(msg, 24, ""),
    citizenship: jspb.Message.getFieldWithDefault(msg, 25, ""),
    ofacStatus: jspb.Message.getFieldWithDefault(msg, 26, ""),
    ofacDate: (f = msg.getOfacDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    kycStatus: jspb.Message.getFieldWithDefault(msg, 28, ""),
    kycDate: (f = msg.getKycDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    officer: jspb.Message.getBooleanFieldWithDefault(msg, 30, false),
    owner: jspb.Message.getBooleanFieldWithDefault(msg, 31, false),
    ownershipPercent: jspb.Message.getFieldWithDefault(msg, 32, ""),
    relationship: jspb.Message.getFieldWithDefault(msg, 36, ""),
    maritalStatus: jspb.Message.getFieldWithDefault(msg, 37, ""),
    natureOfBusiness: jspb.Message.getFieldWithDefault(msg, 38, ""),
    yearsEmployed: jspb.Message.getFieldWithDefault(msg, 39, 0),
    inactiveStatusReason: jspb.Message.getFieldWithDefault(msg, 40, ""),
    addressesList: jspb.Message.toObjectList(msg.getAddressesList(),
    proto_accountpb_address_pb.Address.toObject, includeInstance),
    contactInfosList: jspb.Message.toObjectList(msg.getContactInfosList(),
    proto_accountpb_contactinfo_pb.ContactInfo.toObject, includeInstance),
    suffix: jspb.Message.getFieldWithDefault(msg, 50, ""),
    previousEmploymentName: jspb.Message.getFieldWithDefault(msg, 51, ""),
    piiAccess: jspb.Message.getBooleanFieldWithDefault(msg, 52, false),
    isEdit: jspb.Message.getBooleanFieldWithDefault(msg, 55, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountpb.Owner}
 */
proto.accountpb.Owner.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountpb.Owner;
  return proto.accountpb.Owner.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountpb.Owner} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountpb.Owner}
 */
proto.accountpb.Owner.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setOwnerId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAccountId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setOwnerType(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirstName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setMiddleName(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastName(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedBy(value);
      break;
    case 9:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setDateOfBirth(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmploymentStatus(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmploymentOccupation(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmploymentName(value);
      break;
    case 14:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOwnership(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setStockOwnership(value);
      break;
    case 16:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBrokerMember(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrokerName(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setAffiliatePerson(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setAffiliatePersonPosition(value);
      break;
    case 20:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setModifiedAt(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setModifiedBy(value);
      break;
    case 22:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 23:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorrespondent(value);
      break;
    case 24:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountNo(value);
      break;
    case 25:
      var value = /** @type {string} */ (reader.readString());
      msg.setCitizenship(value);
      break;
    case 26:
      var value = /** @type {string} */ (reader.readString());
      msg.setOfacStatus(value);
      break;
    case 27:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setOfacDate(value);
      break;
    case 28:
      var value = /** @type {string} */ (reader.readString());
      msg.setKycStatus(value);
      break;
    case 29:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setKycDate(value);
      break;
    case 30:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOfficer(value);
      break;
    case 31:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOwner(value);
      break;
    case 32:
      var value = /** @type {string} */ (reader.readString());
      msg.setOwnershipPercent(value);
      break;
    case 36:
      var value = /** @type {string} */ (reader.readString());
      msg.setRelationship(value);
      break;
    case 37:
      var value = /** @type {string} */ (reader.readString());
      msg.setMaritalStatus(value);
      break;
    case 38:
      var value = /** @type {string} */ (reader.readString());
      msg.setNatureOfBusiness(value);
      break;
    case 39:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setYearsEmployed(value);
      break;
    case 40:
      var value = /** @type {string} */ (reader.readString());
      msg.setInactiveStatusReason(value);
      break;
    case 48:
      var value = new proto_accountpb_address_pb.Address;
      reader.readMessage(value,proto_accountpb_address_pb.Address.deserializeBinaryFromReader);
      msg.addAddresses(value);
      break;
    case 49:
      var value = new proto_accountpb_contactinfo_pb.ContactInfo;
      reader.readMessage(value,proto_accountpb_contactinfo_pb.ContactInfo.deserializeBinaryFromReader);
      msg.addContactInfos(value);
      break;
    case 50:
      var value = /** @type {string} */ (reader.readString());
      msg.setSuffix(value);
      break;
    case 51:
      var value = /** @type {string} */ (reader.readString());
      msg.setPreviousEmploymentName(value);
      break;
    case 52:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPiiAccess(value);
      break;
    case 55:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsEdit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountpb.Owner.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountpb.Owner.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountpb.Owner} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountpb.Owner.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOwnerId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getOwnerType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getFirstName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getMiddleName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getLastName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getCreatedBy();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getDateOfBirth();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getEmploymentStatus();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getEmploymentOccupation();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getEmploymentName();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getOwnership();
  if (f) {
    writer.writeBool(
      14,
      f
    );
  }
  f = message.getStockOwnership();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getBrokerMember();
  if (f) {
    writer.writeBool(
      16,
      f
    );
  }
  f = message.getBrokerName();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getAffiliatePerson();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getAffiliatePersonPosition();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getModifiedAt();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getModifiedBy();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCorrespondent();
  if (f.length > 0) {
    writer.writeString(
      23,
      f
    );
  }
  f = message.getAccountNo();
  if (f.length > 0) {
    writer.writeString(
      24,
      f
    );
  }
  f = message.getCitizenship();
  if (f.length > 0) {
    writer.writeString(
      25,
      f
    );
  }
  f = message.getOfacStatus();
  if (f.length > 0) {
    writer.writeString(
      26,
      f
    );
  }
  f = message.getOfacDate();
  if (f != null) {
    writer.writeMessage(
      27,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getKycStatus();
  if (f.length > 0) {
    writer.writeString(
      28,
      f
    );
  }
  f = message.getKycDate();
  if (f != null) {
    writer.writeMessage(
      29,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getOfficer();
  if (f) {
    writer.writeBool(
      30,
      f
    );
  }
  f = message.getOwner();
  if (f) {
    writer.writeBool(
      31,
      f
    );
  }
  f = message.getOwnershipPercent();
  if (f.length > 0) {
    writer.writeString(
      32,
      f
    );
  }
  f = message.getRelationship();
  if (f.length > 0) {
    writer.writeString(
      36,
      f
    );
  }
  f = message.getMaritalStatus();
  if (f.length > 0) {
    writer.writeString(
      37,
      f
    );
  }
  f = message.getNatureOfBusiness();
  if (f.length > 0) {
    writer.writeString(
      38,
      f
    );
  }
  f = message.getYearsEmployed();
  if (f !== 0) {
    writer.writeInt32(
      39,
      f
    );
  }
  f = message.getInactiveStatusReason();
  if (f.length > 0) {
    writer.writeString(
      40,
      f
    );
  }
  f = message.getAddressesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      48,
      f,
      proto_accountpb_address_pb.Address.serializeBinaryToWriter
    );
  }
  f = message.getContactInfosList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      49,
      f,
      proto_accountpb_contactinfo_pb.ContactInfo.serializeBinaryToWriter
    );
  }
  f = message.getSuffix();
  if (f.length > 0) {
    writer.writeString(
      50,
      f
    );
  }
  f = message.getPreviousEmploymentName();
  if (f.length > 0) {
    writer.writeString(
      51,
      f
    );
  }
  f = message.getPiiAccess();
  if (f) {
    writer.writeBool(
      52,
      f
    );
  }
  f = message.getIsEdit();
  if (f) {
    writer.writeBool(
      55,
      f
    );
  }
};


/**
 * optional uint32 owner_id = 1;
 * @return {number}
 */
proto.accountpb.Owner.prototype.getOwnerId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountpb.Owner} returns this
 */
proto.accountpb.Owner.prototype.setOwnerId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 account_id = 2;
 * @return {number}
 */
proto.accountpb.Owner.prototype.getAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountpb.Owner} returns this
 */
proto.accountpb.Owner.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string owner_type = 3;
 * @return {string}
 */
proto.accountpb.Owner.prototype.getOwnerType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Owner} returns this
 */
proto.accountpb.Owner.prototype.setOwnerType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string first_name = 4;
 * @return {string}
 */
proto.accountpb.Owner.prototype.getFirstName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Owner} returns this
 */
proto.accountpb.Owner.prototype.setFirstName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string middle_name = 5;
 * @return {string}
 */
proto.accountpb.Owner.prototype.getMiddleName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Owner} returns this
 */
proto.accountpb.Owner.prototype.setMiddleName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string last_name = 6;
 * @return {string}
 */
proto.accountpb.Owner.prototype.getLastName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Owner} returns this
 */
proto.accountpb.Owner.prototype.setLastName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string status = 7;
 * @return {string}
 */
proto.accountpb.Owner.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Owner} returns this
 */
proto.accountpb.Owner.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string created_by = 8;
 * @return {string}
 */
proto.accountpb.Owner.prototype.getCreatedBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Owner} returns this
 */
proto.accountpb.Owner.prototype.setCreatedBy = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional google.type.Date date_of_birth = 9;
 * @return {?proto.google.type.Date}
 */
proto.accountpb.Owner.prototype.getDateOfBirth = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 9));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.accountpb.Owner} returns this
*/
proto.accountpb.Owner.prototype.setDateOfBirth = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountpb.Owner} returns this
 */
proto.accountpb.Owner.prototype.clearDateOfBirth = function() {
  return this.setDateOfBirth(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountpb.Owner.prototype.hasDateOfBirth = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional string country = 10;
 * @return {string}
 */
proto.accountpb.Owner.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Owner} returns this
 */
proto.accountpb.Owner.prototype.setCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string employment_status = 11;
 * @return {string}
 */
proto.accountpb.Owner.prototype.getEmploymentStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Owner} returns this
 */
proto.accountpb.Owner.prototype.setEmploymentStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string employment_occupation = 12;
 * @return {string}
 */
proto.accountpb.Owner.prototype.getEmploymentOccupation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Owner} returns this
 */
proto.accountpb.Owner.prototype.setEmploymentOccupation = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string employment_name = 13;
 * @return {string}
 */
proto.accountpb.Owner.prototype.getEmploymentName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Owner} returns this
 */
proto.accountpb.Owner.prototype.setEmploymentName = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional bool ownership = 14;
 * @return {boolean}
 */
proto.accountpb.Owner.prototype.getOwnership = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 14, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountpb.Owner} returns this
 */
proto.accountpb.Owner.prototype.setOwnership = function(value) {
  return jspb.Message.setProto3BooleanField(this, 14, value);
};


/**
 * optional string stock_ownership = 15;
 * @return {string}
 */
proto.accountpb.Owner.prototype.getStockOwnership = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Owner} returns this
 */
proto.accountpb.Owner.prototype.setStockOwnership = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional bool broker_member = 16;
 * @return {boolean}
 */
proto.accountpb.Owner.prototype.getBrokerMember = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 16, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountpb.Owner} returns this
 */
proto.accountpb.Owner.prototype.setBrokerMember = function(value) {
  return jspb.Message.setProto3BooleanField(this, 16, value);
};


/**
 * optional string broker_name = 17;
 * @return {string}
 */
proto.accountpb.Owner.prototype.getBrokerName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Owner} returns this
 */
proto.accountpb.Owner.prototype.setBrokerName = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string affiliate_person = 18;
 * @return {string}
 */
proto.accountpb.Owner.prototype.getAffiliatePerson = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Owner} returns this
 */
proto.accountpb.Owner.prototype.setAffiliatePerson = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string affiliate_person_position = 19;
 * @return {string}
 */
proto.accountpb.Owner.prototype.getAffiliatePersonPosition = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Owner} returns this
 */
proto.accountpb.Owner.prototype.setAffiliatePersonPosition = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional google.protobuf.Timestamp modified_at = 20;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.accountpb.Owner.prototype.getModifiedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 20));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.accountpb.Owner} returns this
*/
proto.accountpb.Owner.prototype.setModifiedAt = function(value) {
  return jspb.Message.setWrapperField(this, 20, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountpb.Owner} returns this
 */
proto.accountpb.Owner.prototype.clearModifiedAt = function() {
  return this.setModifiedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountpb.Owner.prototype.hasModifiedAt = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional string modified_by = 21;
 * @return {string}
 */
proto.accountpb.Owner.prototype.getModifiedBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Owner} returns this
 */
proto.accountpb.Owner.prototype.setModifiedBy = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 22;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.accountpb.Owner.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 22));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.accountpb.Owner} returns this
*/
proto.accountpb.Owner.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 22, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountpb.Owner} returns this
 */
proto.accountpb.Owner.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountpb.Owner.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional string correspondent = 23;
 * @return {string}
 */
proto.accountpb.Owner.prototype.getCorrespondent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Owner} returns this
 */
proto.accountpb.Owner.prototype.setCorrespondent = function(value) {
  return jspb.Message.setProto3StringField(this, 23, value);
};


/**
 * optional string account_no = 24;
 * @return {string}
 */
proto.accountpb.Owner.prototype.getAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Owner} returns this
 */
proto.accountpb.Owner.prototype.setAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 24, value);
};


/**
 * optional string citizenship = 25;
 * @return {string}
 */
proto.accountpb.Owner.prototype.getCitizenship = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 25, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Owner} returns this
 */
proto.accountpb.Owner.prototype.setCitizenship = function(value) {
  return jspb.Message.setProto3StringField(this, 25, value);
};


/**
 * optional string ofac_status = 26;
 * @return {string}
 */
proto.accountpb.Owner.prototype.getOfacStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Owner} returns this
 */
proto.accountpb.Owner.prototype.setOfacStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 26, value);
};


/**
 * optional google.type.Date ofac_date = 27;
 * @return {?proto.google.type.Date}
 */
proto.accountpb.Owner.prototype.getOfacDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 27));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.accountpb.Owner} returns this
*/
proto.accountpb.Owner.prototype.setOfacDate = function(value) {
  return jspb.Message.setWrapperField(this, 27, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountpb.Owner} returns this
 */
proto.accountpb.Owner.prototype.clearOfacDate = function() {
  return this.setOfacDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountpb.Owner.prototype.hasOfacDate = function() {
  return jspb.Message.getField(this, 27) != null;
};


/**
 * optional string kyc_status = 28;
 * @return {string}
 */
proto.accountpb.Owner.prototype.getKycStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Owner} returns this
 */
proto.accountpb.Owner.prototype.setKycStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 28, value);
};


/**
 * optional google.type.Date kyc_date = 29;
 * @return {?proto.google.type.Date}
 */
proto.accountpb.Owner.prototype.getKycDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 29));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.accountpb.Owner} returns this
*/
proto.accountpb.Owner.prototype.setKycDate = function(value) {
  return jspb.Message.setWrapperField(this, 29, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountpb.Owner} returns this
 */
proto.accountpb.Owner.prototype.clearKycDate = function() {
  return this.setKycDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountpb.Owner.prototype.hasKycDate = function() {
  return jspb.Message.getField(this, 29) != null;
};


/**
 * optional bool officer = 30;
 * @return {boolean}
 */
proto.accountpb.Owner.prototype.getOfficer = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 30, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountpb.Owner} returns this
 */
proto.accountpb.Owner.prototype.setOfficer = function(value) {
  return jspb.Message.setProto3BooleanField(this, 30, value);
};


/**
 * optional bool owner = 31;
 * @return {boolean}
 */
proto.accountpb.Owner.prototype.getOwner = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 31, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountpb.Owner} returns this
 */
proto.accountpb.Owner.prototype.setOwner = function(value) {
  return jspb.Message.setProto3BooleanField(this, 31, value);
};


/**
 * optional string ownership_percent = 32;
 * @return {string}
 */
proto.accountpb.Owner.prototype.getOwnershipPercent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 32, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Owner} returns this
 */
proto.accountpb.Owner.prototype.setOwnershipPercent = function(value) {
  return jspb.Message.setProto3StringField(this, 32, value);
};


/**
 * optional string relationship = 36;
 * @return {string}
 */
proto.accountpb.Owner.prototype.getRelationship = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 36, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Owner} returns this
 */
proto.accountpb.Owner.prototype.setRelationship = function(value) {
  return jspb.Message.setProto3StringField(this, 36, value);
};


/**
 * optional string marital_status = 37;
 * @return {string}
 */
proto.accountpb.Owner.prototype.getMaritalStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 37, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Owner} returns this
 */
proto.accountpb.Owner.prototype.setMaritalStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 37, value);
};


/**
 * optional string nature_of_business = 38;
 * @return {string}
 */
proto.accountpb.Owner.prototype.getNatureOfBusiness = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 38, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Owner} returns this
 */
proto.accountpb.Owner.prototype.setNatureOfBusiness = function(value) {
  return jspb.Message.setProto3StringField(this, 38, value);
};


/**
 * optional int32 years_employed = 39;
 * @return {number}
 */
proto.accountpb.Owner.prototype.getYearsEmployed = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 39, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountpb.Owner} returns this
 */
proto.accountpb.Owner.prototype.setYearsEmployed = function(value) {
  return jspb.Message.setProto3IntField(this, 39, value);
};


/**
 * optional string inactive_status_reason = 40;
 * @return {string}
 */
proto.accountpb.Owner.prototype.getInactiveStatusReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 40, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Owner} returns this
 */
proto.accountpb.Owner.prototype.setInactiveStatusReason = function(value) {
  return jspb.Message.setProto3StringField(this, 40, value);
};


/**
 * repeated Address addresses = 48;
 * @return {!Array<!proto.accountpb.Address>}
 */
proto.accountpb.Owner.prototype.getAddressesList = function() {
  return /** @type{!Array<!proto.accountpb.Address>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_accountpb_address_pb.Address, 48));
};


/**
 * @param {!Array<!proto.accountpb.Address>} value
 * @return {!proto.accountpb.Owner} returns this
*/
proto.accountpb.Owner.prototype.setAddressesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 48, value);
};


/**
 * @param {!proto.accountpb.Address=} opt_value
 * @param {number=} opt_index
 * @return {!proto.accountpb.Address}
 */
proto.accountpb.Owner.prototype.addAddresses = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 48, opt_value, proto.accountpb.Address, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountpb.Owner} returns this
 */
proto.accountpb.Owner.prototype.clearAddressesList = function() {
  return this.setAddressesList([]);
};


/**
 * repeated ContactInfo contact_infos = 49;
 * @return {!Array<!proto.accountpb.ContactInfo>}
 */
proto.accountpb.Owner.prototype.getContactInfosList = function() {
  return /** @type{!Array<!proto.accountpb.ContactInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_accountpb_contactinfo_pb.ContactInfo, 49));
};


/**
 * @param {!Array<!proto.accountpb.ContactInfo>} value
 * @return {!proto.accountpb.Owner} returns this
*/
proto.accountpb.Owner.prototype.setContactInfosList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 49, value);
};


/**
 * @param {!proto.accountpb.ContactInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.accountpb.ContactInfo}
 */
proto.accountpb.Owner.prototype.addContactInfos = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 49, opt_value, proto.accountpb.ContactInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountpb.Owner} returns this
 */
proto.accountpb.Owner.prototype.clearContactInfosList = function() {
  return this.setContactInfosList([]);
};


/**
 * optional string suffix = 50;
 * @return {string}
 */
proto.accountpb.Owner.prototype.getSuffix = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 50, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Owner} returns this
 */
proto.accountpb.Owner.prototype.setSuffix = function(value) {
  return jspb.Message.setProto3StringField(this, 50, value);
};


/**
 * optional string previous_employment_name = 51;
 * @return {string}
 */
proto.accountpb.Owner.prototype.getPreviousEmploymentName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 51, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Owner} returns this
 */
proto.accountpb.Owner.prototype.setPreviousEmploymentName = function(value) {
  return jspb.Message.setProto3StringField(this, 51, value);
};


/**
 * optional bool pii_access = 52;
 * @return {boolean}
 */
proto.accountpb.Owner.prototype.getPiiAccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 52, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountpb.Owner} returns this
 */
proto.accountpb.Owner.prototype.setPiiAccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 52, value);
};


/**
 * optional bool is_edit = 55;
 * @return {boolean}
 */
proto.accountpb.Owner.prototype.getIsEdit = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 55, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountpb.Owner} returns this
 */
proto.accountpb.Owner.prototype.setIsEdit = function(value) {
  return jspb.Message.setProto3BooleanField(this, 55, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountpb.CreateOwnerResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.accountpb.CreateOwnerResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountpb.CreateOwnerResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountpb.CreateOwnerResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    owner: (f = msg.getOwner()) && proto.accountpb.Owner.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountpb.CreateOwnerResponse}
 */
proto.accountpb.CreateOwnerResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountpb.CreateOwnerResponse;
  return proto.accountpb.CreateOwnerResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountpb.CreateOwnerResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountpb.CreateOwnerResponse}
 */
proto.accountpb.CreateOwnerResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.accountpb.Owner;
      reader.readMessage(value,proto.accountpb.Owner.deserializeBinaryFromReader);
      msg.setOwner(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountpb.CreateOwnerResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountpb.CreateOwnerResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountpb.CreateOwnerResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountpb.CreateOwnerResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOwner();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.accountpb.Owner.serializeBinaryToWriter
    );
  }
};


/**
 * optional Owner owner = 1;
 * @return {?proto.accountpb.Owner}
 */
proto.accountpb.CreateOwnerResponse.prototype.getOwner = function() {
  return /** @type{?proto.accountpb.Owner} */ (
    jspb.Message.getWrapperField(this, proto.accountpb.Owner, 1));
};


/**
 * @param {?proto.accountpb.Owner|undefined} value
 * @return {!proto.accountpb.CreateOwnerResponse} returns this
*/
proto.accountpb.CreateOwnerResponse.prototype.setOwner = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountpb.CreateOwnerResponse} returns this
 */
proto.accountpb.CreateOwnerResponse.prototype.clearOwner = function() {
  return this.setOwner(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountpb.CreateOwnerResponse.prototype.hasOwner = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountpb.UpdateOwnerResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.accountpb.UpdateOwnerResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountpb.UpdateOwnerResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountpb.UpdateOwnerResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    owner: (f = msg.getOwner()) && proto.accountpb.Owner.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountpb.UpdateOwnerResponse}
 */
proto.accountpb.UpdateOwnerResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountpb.UpdateOwnerResponse;
  return proto.accountpb.UpdateOwnerResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountpb.UpdateOwnerResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountpb.UpdateOwnerResponse}
 */
proto.accountpb.UpdateOwnerResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.accountpb.Owner;
      reader.readMessage(value,proto.accountpb.Owner.deserializeBinaryFromReader);
      msg.setOwner(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountpb.UpdateOwnerResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountpb.UpdateOwnerResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountpb.UpdateOwnerResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountpb.UpdateOwnerResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOwner();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.accountpb.Owner.serializeBinaryToWriter
    );
  }
};


/**
 * optional Owner owner = 1;
 * @return {?proto.accountpb.Owner}
 */
proto.accountpb.UpdateOwnerResponse.prototype.getOwner = function() {
  return /** @type{?proto.accountpb.Owner} */ (
    jspb.Message.getWrapperField(this, proto.accountpb.Owner, 1));
};


/**
 * @param {?proto.accountpb.Owner|undefined} value
 * @return {!proto.accountpb.UpdateOwnerResponse} returns this
*/
proto.accountpb.UpdateOwnerResponse.prototype.setOwner = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountpb.UpdateOwnerResponse} returns this
 */
proto.accountpb.UpdateOwnerResponse.prototype.clearOwner = function() {
  return this.setOwner(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountpb.UpdateOwnerResponse.prototype.hasOwner = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountpb.BatchCreateOwnerRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountpb.BatchCreateOwnerRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.accountpb.BatchCreateOwnerRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountpb.BatchCreateOwnerRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountpb.BatchCreateOwnerRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    ownerList: jspb.Message.toObjectList(msg.getOwnerList(),
    proto.accountpb.Owner.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountpb.BatchCreateOwnerRequest}
 */
proto.accountpb.BatchCreateOwnerRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountpb.BatchCreateOwnerRequest;
  return proto.accountpb.BatchCreateOwnerRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountpb.BatchCreateOwnerRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountpb.BatchCreateOwnerRequest}
 */
proto.accountpb.BatchCreateOwnerRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.accountpb.Owner;
      reader.readMessage(value,proto.accountpb.Owner.deserializeBinaryFromReader);
      msg.addOwner(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountpb.BatchCreateOwnerRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountpb.BatchCreateOwnerRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountpb.BatchCreateOwnerRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountpb.BatchCreateOwnerRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOwnerList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.accountpb.Owner.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Owner owner = 1;
 * @return {!Array<!proto.accountpb.Owner>}
 */
proto.accountpb.BatchCreateOwnerRequest.prototype.getOwnerList = function() {
  return /** @type{!Array<!proto.accountpb.Owner>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.accountpb.Owner, 1));
};


/**
 * @param {!Array<!proto.accountpb.Owner>} value
 * @return {!proto.accountpb.BatchCreateOwnerRequest} returns this
*/
proto.accountpb.BatchCreateOwnerRequest.prototype.setOwnerList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.accountpb.Owner=} opt_value
 * @param {number=} opt_index
 * @return {!proto.accountpb.Owner}
 */
proto.accountpb.BatchCreateOwnerRequest.prototype.addOwner = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.accountpb.Owner, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountpb.BatchCreateOwnerRequest} returns this
 */
proto.accountpb.BatchCreateOwnerRequest.prototype.clearOwnerList = function() {
  return this.setOwnerList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountpb.BatchCreateOwnerResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountpb.BatchCreateOwnerResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.accountpb.BatchCreateOwnerResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountpb.BatchCreateOwnerResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountpb.BatchCreateOwnerResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    ownerResponsesList: jspb.Message.toObjectList(msg.getOwnerResponsesList(),
    proto.accountpb.Owner.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountpb.BatchCreateOwnerResponse}
 */
proto.accountpb.BatchCreateOwnerResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountpb.BatchCreateOwnerResponse;
  return proto.accountpb.BatchCreateOwnerResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountpb.BatchCreateOwnerResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountpb.BatchCreateOwnerResponse}
 */
proto.accountpb.BatchCreateOwnerResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.accountpb.Owner;
      reader.readMessage(value,proto.accountpb.Owner.deserializeBinaryFromReader);
      msg.addOwnerResponses(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountpb.BatchCreateOwnerResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountpb.BatchCreateOwnerResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountpb.BatchCreateOwnerResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountpb.BatchCreateOwnerResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOwnerResponsesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.accountpb.Owner.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Owner owner_responses = 1;
 * @return {!Array<!proto.accountpb.Owner>}
 */
proto.accountpb.BatchCreateOwnerResponse.prototype.getOwnerResponsesList = function() {
  return /** @type{!Array<!proto.accountpb.Owner>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.accountpb.Owner, 1));
};


/**
 * @param {!Array<!proto.accountpb.Owner>} value
 * @return {!proto.accountpb.BatchCreateOwnerResponse} returns this
*/
proto.accountpb.BatchCreateOwnerResponse.prototype.setOwnerResponsesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.accountpb.Owner=} opt_value
 * @param {number=} opt_index
 * @return {!proto.accountpb.Owner}
 */
proto.accountpb.BatchCreateOwnerResponse.prototype.addOwnerResponses = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.accountpb.Owner, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountpb.BatchCreateOwnerResponse} returns this
 */
proto.accountpb.BatchCreateOwnerResponse.prototype.clearOwnerResponsesList = function() {
  return this.setOwnerResponsesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountpb.OwnerAutoFill.prototype.toObject = function(opt_includeInstance) {
  return proto.accountpb.OwnerAutoFill.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountpb.OwnerAutoFill} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountpb.OwnerAutoFill.toObject = function(includeInstance, msg) {
  var f, obj = {
    ownerId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    owner: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountpb.OwnerAutoFill}
 */
proto.accountpb.OwnerAutoFill.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountpb.OwnerAutoFill;
  return proto.accountpb.OwnerAutoFill.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountpb.OwnerAutoFill} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountpb.OwnerAutoFill}
 */
proto.accountpb.OwnerAutoFill.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setOwnerId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOwner(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountpb.OwnerAutoFill.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountpb.OwnerAutoFill.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountpb.OwnerAutoFill} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountpb.OwnerAutoFill.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOwnerId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getOwner();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional uint32 owner_id = 1;
 * @return {number}
 */
proto.accountpb.OwnerAutoFill.prototype.getOwnerId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountpb.OwnerAutoFill} returns this
 */
proto.accountpb.OwnerAutoFill.prototype.setOwnerId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string owner = 2;
 * @return {string}
 */
proto.accountpb.OwnerAutoFill.prototype.getOwner = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.OwnerAutoFill} returns this
 */
proto.accountpb.OwnerAutoFill.prototype.setOwner = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountpb.ListOwnerAutoFillRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.accountpb.ListOwnerAutoFillRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountpb.ListOwnerAutoFillRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountpb.ListOwnerAutoFillRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountId: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountpb.ListOwnerAutoFillRequest}
 */
proto.accountpb.ListOwnerAutoFillRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountpb.ListOwnerAutoFillRequest;
  return proto.accountpb.ListOwnerAutoFillRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountpb.ListOwnerAutoFillRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountpb.ListOwnerAutoFillRequest}
 */
proto.accountpb.ListOwnerAutoFillRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAccountId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountpb.ListOwnerAutoFillRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountpb.ListOwnerAutoFillRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountpb.ListOwnerAutoFillRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountpb.ListOwnerAutoFillRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
};


/**
 * optional uint32 account_id = 2;
 * @return {number}
 */
proto.accountpb.ListOwnerAutoFillRequest.prototype.getAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountpb.ListOwnerAutoFillRequest} returns this
 */
proto.accountpb.ListOwnerAutoFillRequest.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountpb.ListOwnerAutoFillResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountpb.ListOwnerAutoFillResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.accountpb.ListOwnerAutoFillResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountpb.ListOwnerAutoFillResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountpb.ListOwnerAutoFillResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    ownerAutoFillList: jspb.Message.toObjectList(msg.getOwnerAutoFillList(),
    proto.accountpb.OwnerAutoFill.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountpb.ListOwnerAutoFillResponse}
 */
proto.accountpb.ListOwnerAutoFillResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountpb.ListOwnerAutoFillResponse;
  return proto.accountpb.ListOwnerAutoFillResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountpb.ListOwnerAutoFillResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountpb.ListOwnerAutoFillResponse}
 */
proto.accountpb.ListOwnerAutoFillResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.accountpb.OwnerAutoFill;
      reader.readMessage(value,proto.accountpb.OwnerAutoFill.deserializeBinaryFromReader);
      msg.addOwnerAutoFill(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountpb.ListOwnerAutoFillResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountpb.ListOwnerAutoFillResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountpb.ListOwnerAutoFillResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountpb.ListOwnerAutoFillResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOwnerAutoFillList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.accountpb.OwnerAutoFill.serializeBinaryToWriter
    );
  }
};


/**
 * repeated OwnerAutoFill owner_auto_fill = 1;
 * @return {!Array<!proto.accountpb.OwnerAutoFill>}
 */
proto.accountpb.ListOwnerAutoFillResponse.prototype.getOwnerAutoFillList = function() {
  return /** @type{!Array<!proto.accountpb.OwnerAutoFill>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.accountpb.OwnerAutoFill, 1));
};


/**
 * @param {!Array<!proto.accountpb.OwnerAutoFill>} value
 * @return {!proto.accountpb.ListOwnerAutoFillResponse} returns this
*/
proto.accountpb.ListOwnerAutoFillResponse.prototype.setOwnerAutoFillList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.accountpb.OwnerAutoFill=} opt_value
 * @param {number=} opt_index
 * @return {!proto.accountpb.OwnerAutoFill}
 */
proto.accountpb.ListOwnerAutoFillResponse.prototype.addOwnerAutoFill = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.accountpb.OwnerAutoFill, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountpb.ListOwnerAutoFillResponse} returns this
 */
proto.accountpb.ListOwnerAutoFillResponse.prototype.clearOwnerAutoFillList = function() {
  return this.setOwnerAutoFillList([]);
};


goog.object.extend(exports, proto.accountpb);
